import raw from '../data/products.json'
import seoMap from '../data/seo.json'
import aplusMap from '../data/aplus.json'
import faqsMap from '../data/faqs.json'
import { hydrateProduct } from './compute'

type Product = any
const rawProducts = (raw as unknown as Product[])

function mergeOverlays(p: any) {
  const slug = p?.slug || ''
  const seo = (seoMap as any)?.[slug] || null
  const aplus = (aplusMap as any)?.[slug] || null
  const faqs = (faqsMap as any)?.[slug] || null
  return {
    ...p,
    seo: seo ? { ...(p.seo || {}), ...seo } : (p.seo || undefined),
    aPlusContent: aplus ?? p.aPlusContent ?? undefined,
    faqs: Array.isArray(faqs) ? faqs : (p.faqs || undefined),
  }
}

export const products = rawProducts.map(hydrateProduct).map(mergeOverlays)

export function listProducts() {
  const order = [
    'runner-rug-for-bedroom-and-doorway',
    'rabbit-fur-runner',
    'runner-rug-and-floor-mat-combo',
    'microfiber-floor-mat',
  ]
  const rank = new Map(order.map((slug, i) => [slug, i]))
  return [...products].sort((a: any, b: any) => {
    const aRank = rank.has(a?.slug) ? rank.get(a?.slug)! : Number.MAX_SAFE_INTEGER
    const bRank = rank.has(b?.slug) ? rank.get(b?.slug)! : Number.MAX_SAFE_INTEGER
    return aRank - bRank
  })
}
export function findBySlug(slug: string) { return products.find((p: any) => p.slug === slug) }
export function listCategory(slug: string) {
  const defs = [
    { slug: 'fur-rugs',    test: (p: any) => /faux rabbit fur|PlushFur|fur rug/i.test(`${p.title} ${p.collection || ''}`) },
    { slug: 'runner-rugs', test: (p: any) => (/runners/i.test(p.category || '') || /runner rug|runner/i.test(p.title)) && !/faux rabbit fur|PlushFur|fur rug/i.test(`${p.title} ${p.collection || ''}`) },
    { slug: 'floor-mats',  test: (p: any) => /floor mats?/i.test(p.category || '') || /floor mat|door mat/i.test(p.title) },
    { slug: 'door-mats',   test: (p: any) => /floor mats?/i.test(p.category || '') || /door mat/i.test(p.title) },
  ]
  const def = defs.find(d => d.slug === slug)
  if (!def) return []
  return products.filter(def.test)
}

export function defaultVariantColor(p: any): string | null {
  try {
    const id = p?.variants?.defaultId
    const opt = (p?.variants?.options || []).find((o: any) => o.id === id)
    return opt?.label || null
  } catch (_) { return null }
}

export function categorySlugForProduct(p: any): string | null {
  if (!p) return null
  const tests: { slug: string; test: (x: any) => boolean }[] = [
    { slug: 'fur-rugs',    test: (x) => /faux rabbit fur|PlushFur|fur rug/i.test(`${x.title} ${x.collection || ''}`) },
    { slug: 'runner-rugs', test: (x) => (/runners|runner/i.test(x.category || '') || /runner rug|runner/i.test(x.title)) && !/faux rabbit fur|PlushFur|fur rug/i.test(`${x.title} ${x.collection || ''}`) },
    { slug: 'door-mats',   test: (x) => /door mat/i.test(x.title) || /floor mats?/i.test(x.category || '') },
    { slug: 'floor-mats',  test: (x) => /floor mat/i.test(x.title) || /floor mats?/i.test(x.category || '') },
  ]
  const hit = tests.find(t => t.test(p))
  return hit ? hit.slug : null
}
